module.exports = __webpack_public_path__ + "img/10.ffe3bb4c.png";